import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface ContextButtonProps {
  /**
   * Whether the context is selected/added
   */
  contextSelected: boolean;
  /**
   * Whether the button should be disabled
   */
  disabled?: boolean;
  /**
   * Whether the component is in a loading state
   */
  loading?: boolean;
  /**
   * Click handler for the button
   */
  onClick?: () => void;
  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * Pure UI component for the context button
 * No business logic, only UI presentation
 */
export function ContextButton({
  contextSelected,
  disabled = false,
  loading = false,
  onClick,
  className,
}: ContextButtonProps) {
  if (loading) {
    return (
      <Button
        variant="outline"
        className={cn(
          "w-full sm:min-w-[140px] sm:w-auto h-10 opacity-50 cursor-not-allowed",
          className,
        )}
        disabled
      >
        Context
      </Button>
    );
  }

  return (
    <Button
      variant="outline"
      className={cn(
        "w-full sm:min-w-[140px] sm:w-auto h-10",
        disabled && "opacity-50 cursor-not-allowed",
        contextSelected && "border-primary text-primary",
        className,
      )}
      disabled={disabled}
      onClick={onClick}
    >
      {contextSelected ? "Context Added" : "Add Context"}
    </Button>
  );
}

